<template>
  <footer>
    <div class="footer-inner">

      <div class="intouch">
        <router-link :to="'/contact'"><svg id="beintouch" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 212.75 116.6"><path d="M31.13 44.81a13.36 13.36 0 0 0 4.68-2.64 9.76 9.76 0 0 0 2.65-3.92 13.71 13.71 0 0 0 .79-4.59 15.63 15.63 0 0 0-.46-3.9 8.94 8.94 0 0 0-1.65-3.27 10.55 10.55 0 0 0-3.24-2.6 22.15 22.15 0 0 0-5.22-1.95l-.07-.12h-.1a.26.26 0 0 1 .14-.26h.12a28.15 28.15 0 0 0 5.11-1.75 10.49 10.49 0 0 0 3.24-2.31 7.53 7.53 0 0 0 1.66-3 12.75 12.75 0 0 0 .47-3.57 11 11 0 0 0-.8-4.16 8.8 8.8 0 0 0-2.66-3.5A13.8 13.8 0 0 0 31.11.88 23.8 23.8 0 0 0 24.2 0H2.54v45.79H24.2a21.55 21.55 0 0 0 6.93-.98Zm-3.76-25a2.06 2.06 0 0 0-.71.75 2.27 2.27 0 0 0-.29 1.2 2 2 0 0 0 .3 1.13 2.27 2.27 0 0 0 .65.69 4.29 4.29 0 0 0 .93.44 21 21 0 0 1 4.35 1.71 9.37 9.37 0 0 1 2.68 2.13 7.4 7.4 0 0 1 1.4 2.62 11.39 11.39 0 0 1 .42 3.16 10.41 10.41 0 0 1-.69 3.79 8.6 8.6 0 0 1-2.19 3.15 11.14 11.14 0 0 1-4 2.22 19.23 19.23 0 0 1-6.06.83H4.69V2.14H24.2a21.63 21.63 0 0 1 6.08.74 11.81 11.81 0 0 1 4 2 7.2 7.2 0 0 1 2.17 2.76 8.31 8.31 0 0 1 .69 3.33 9 9 0 0 1-.42 2.83 5.83 5.83 0 0 1-1.41 2.2 9.68 9.68 0 0 1-2.7 1.87 22.58 22.58 0 0 1-4.36 1.56 2.49 2.49 0 0 0-.88.4ZM76.92 43.65H44.2V24.06h32.72v-2.14H44.2V2.79a.66.66 0 0 1 .16-.49.5.5 0 0 1 .42-.16h31.7V0h-31.7a2.62 2.62 0 0 0-2 .82 2.77 2.77 0 0 0-.77 2v43h34.91ZM102.6 0h2.14v45.79h-2.14zM111.61 3.62 143 44.28a3.53 3.53 0 0 0 1 1 2.58 2.58 0 0 0 1.52.47 2.65 2.65 0 0 0 2-.85 2.79 2.79 0 0 0 .81-2V0h-2.14v42.94a.71.71 0 0 1-.19.52.65.65 0 0 1-.87 0 1.4 1.4 0 0 1-.4-.43L111.63.19l-.15-.19h-2v45.79h2.15ZM0 72.38h18.81v43.65h2.14V72.38h18.81v-2.14H0v2.14zM80.08 76.55a24 24 0 0 0-7.46-5 23.53 23.53 0 0 0-18.29 0 23.93 23.93 0 0 0-7.42 5 23.59 23.59 0 0 0-5 7.46A22.94 22.94 0 0 0 40 93.17a22.67 22.67 0 0 0 1.86 9.12 23.75 23.75 0 0 0 12.45 12.46 23.53 23.53 0 0 0 18.29 0 23.64 23.64 0 0 0 12.49-12.46A22.67 22.67 0 0 0 87 93.17 22.93 22.93 0 0 0 85.11 84a23.93 23.93 0 0 0-5.03-7.45Zm-16.62 37.91a20.74 20.74 0 0 1-8.28-1.68 21.42 21.42 0 0 1-6.77-4.56 21.73 21.73 0 0 1-4.57-6.77 20.76 20.76 0 0 1-1.67-8.28 21 21 0 0 1 1.67-8.32 21.3 21.3 0 0 1 11.34-11.36 20.6 20.6 0 0 1 8.28-1.68 20.9 20.9 0 0 1 8.32 1.68 21.16 21.16 0 0 1 11.36 11.36 21 21 0 0 1 1.67 8.32 20.76 20.76 0 0 1-1.67 8.28 21.24 21.24 0 0 1-11.36 11.33 21 21 0 0 1-8.32 1.68ZM124.84 98a16.26 16.26 0 0 1-1.29 6.45 16.4 16.4 0 0 1-8.76 8.72 16.18 16.18 0 0 1-6.41 1.3 15.93 15.93 0 0 1-6.38-1.3 17.2 17.2 0 0 1-5.25-3.51 16.52 16.52 0 0 1-3.54-5.21 16.12 16.12 0 0 1-1.3-6.45V70.24h-2.14V98a18.12 18.12 0 0 0 1.47 7.26 18.63 18.63 0 0 0 9.89 9.88 18.61 18.61 0 0 0 14.5 0 18.72 18.72 0 0 0 5.9-4 19 19 0 0 0 4-5.9A18.12 18.12 0 0 0 127 98V70.24h-2.14ZM171.42 104.22a21.23 21.23 0 0 1-7.58 7.45 21.43 21.43 0 0 1-18.84 1.11 21.42 21.42 0 0 1-6.77-4.56 21.85 21.85 0 0 1-4.57-6.77 20.76 20.76 0 0 1-1.67-8.28 21 21 0 0 1 1.67-8.32 21.64 21.64 0 0 1 4.57-6.8 21.42 21.42 0 0 1 6.77-4.56 21.4 21.4 0 0 1 18 .65 21.33 21.33 0 0 1 7.39 6.24l.3.39 1.7-1.22-.31-.41a24.61 24.61 0 0 0-8.1-6.87 22.51 22.51 0 0 0-10.72-2.6 22.75 22.75 0 0 0-9.13 1.85 23.93 23.93 0 0 0-7.42 5 23.59 23.59 0 0 0-5 7.46 22.94 22.94 0 0 0-1.86 9.16 22.67 22.67 0 0 0 1.86 9.12 23.75 23.75 0 0 0 12.45 12.46 22.75 22.75 0 0 0 9.13 1.85 23.53 23.53 0 0 0 6.17-.81 22.73 22.73 0 0 0 5.55-2.31 24.49 24.49 0 0 0 4.7-3.53 21 21 0 0 0 3.64-4.59l.25-.41-1.86-1.17ZM210.61 70.24v21.92h-32.29V70.24h-2.15v45.79h2.15V94.3h32.29v21.73h2.14V70.24h-2.14z" fill="#fff"/></svg></router-link>
      </div>

        <div class="social">
          <p>
            <a class="instagram" href="https://www.instagram.com/the.renees/"><img src="../assets/instagram.svg" /></a>
            <a class="facebook" href="https://www.facebook.com/therenees/"><img src="../assets/facebook.svg" /></a>
          </p>
          <h4 @click="emailClick()">Subscribe</h4>
        </div>


        <div class="address">
          <p>756 s broadway #709, los angeles, ca 90014</p>
          <p>Company Cell <a href="tel:213.305.0464">213.305.0464</a> | Office <a href="tel:213.315.3000">213.315.3000</a></p>
          <p><a href="mailto:renee@therenees.com">renee@therenees.com</a></p>
          <p class="copyright">
            &copy; 2010 - {{ (new Date()).getFullYear() }} RENEE
          </p>
        </div>



      <div class="logo"><router-link :to="'/'"><img src="../assets/logo-white.png"></router-link></div>



    </div>

  </footer>
</template>

<script>
export default {
  name: 'MainFooter',
  data () {
    return {
    }
  },
  methods: {
    emailClick () {
      this.$emit('showEmailSignup', 'show')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/_mixins.scss";
  footer {
    background: #2f2e2e;
    text-align: center;
    color: #FFF;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    padding: 1em 2em;
    box-sizing: border-box;
    font-family: $futura;
    font-size: 12px;
    @include bp(most) {
      padding: 3em;
    }
    @include bp(medlarge) {
      font-size: 14px;
    }
  }

  .footer-inner{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    align-content: center;
    align-items: center;
    @include bp(most) {
      flex-wrap: nowrap;
      flex-direction: row;
    }
  }

  .footer-inner > div {
    flex-grow: 1;
    &.logo {
      flex-grow: 2;
    }
  }

  .intouch {
    svg {
      width: 103px;
      @include bp(most) {
        width: 165px;
      }
    }
  }

  .logo {
    img {
      height: 30px;
      @include bp(most) {
        height: 92px;
        width: 126px;
      }
    }
  }

  .address {
    text-align: center;
    color: #afafab;
    @include bp(mobile) {
      flex-basis: 100%;
    }
    @include bp(most) {
      text-align: left;
    }
    a {
      text-decoration: none;
      color: #afafab;
      &:hover {
        color: #FFF;
      }
    }
  }

  .social {
    h4 {
      font-family: lulo;
      letter-spacing: -2px;
      font-size: 12px;
      cursor: pointer;
      @include bp(most) {
        font-size: 14px;
      }

      @include bp(medlarge) {
        font-size: 17px;
      }
    }
  }

  .copyright {
    color: $darkgrey;
    @include bp(most) {
      margin-top: 2.75em;
    }
  }

  #beintouch {
    path {
      fill: #FFF;
    }
    &:hover path {
      fill: #b385c3;
    }
  }


</style>



// WEBPACK FOOTER //
// MainFooter.vue?9bba15e2